import React from "react";
import primaryComponents from "../../../../primaryComponents";
import useValidation from "./useValidation";
import { useConnectBusiness } from "./useConnectBusiness";
import secondaryComponents from "../../..";

export const ConnectBusiness = ({ fieldProps = {}, terminalType, ...rest }) => {
  const allFields = fieldProps?.fieldList;
  const {
    isConnectingBusiness,
    formDetails,
    opayIndutries,
    isLoadingIndustries,
    setFormDetails,
    connectBusiness,
  } = useConnectBusiness({
    fieldProps,
    terminalType,
    ...rest,
  });

  const {
    register,
    control,
    formState: { errors },
    handleSubmit,
    trigger,
  } = useValidation({
    ...formDetails,
    providerFields: allFields?.map((item) => {
      return item?.isRequired ? item?.key : "null";
    }),
  });

  return (
    <form
      id={fieldProps?.name}
      onSubmit={handleSubmit(connectBusiness)}
      style={{ margin: "auto", maxWidth: "700px" }}
    >
      <secondaryComponents.LoaderHelper
        isLoading={isLoadingIndustries}
        classNames={"mt-5"}
      >
        {allFields?.map((field, index) => {
          if (field?.fieldType === "SELECT")
            return (
              <React.Fragment key={index}>
                <primaryComponents.SelectFieldV2
                  control={control}
                  classNames="white"
                  label={field?.label}
                  name={field?.key}
                  value={
                    opayIndutries?.find(
                      (opayIndustry) =>
                        `${opayIndustry?.key}` ===
                        `${formDetails?.[field?.key]}`,
                    )?.label || "Select"
                  }
                  idKey={"key"}
                  nameKey={"label"}
                  isRequired={field?.isRequired}
                  register={register}
                  errorMessage={errors?.[field?.key]}
                  options={opayIndutries}
                  onChange={(value) => {
                    setFormDetails((prevState) => ({
                      ...prevState,
                      [field?.key]: value,
                    }));
                  }}
                />
              </React.Fragment>
            );

          return (
            <React.Fragment key={index}>
              <primaryComponents.InputFieldV2
                control={control}
                classNames="white"
                label={field?.label}
                placeholder={`Enter ${field?.label}`}
                name={field?.key}
                value={formDetails?.[field?.key]}
                isRequired={field?.isRequired}
                register={register}
                errorMessage={errors?.[field?.key]}
                onKeyUp={() =>
                  errors?.[field?.key] !== undefined && trigger(field?.key)
                }
                onChange={({ target: { value } }) => {
                  setFormDetails((prevState) => ({
                    ...prevState,
                    [field?.key]: value,
                  }));
                }}
              />
            </React.Fragment>
          );
        })}
      </secondaryComponents.LoaderHelper>

      <primaryComponents.Button
        classNames={"ml-auto btn btn--primary"}
        style={{ width: "200px" }}
        type="submit"
        isDisabled={isConnectingBusiness}
        isLoading={isConnectingBusiness}
        loadingText={"Connecting..."}
      >
        Proceed
      </primaryComponents.Button>
    </form>
  );
};
